<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<mat-divider></mat-divider>
<div
  fxLayout="column"
  fxLayoutGap="1rem"
  [ngClass]="{
    'sc-margin-5': isAlternateFooter && !(isMobileDevice() || isTabDevice()),
    'sc-margin-top-1': isAlternateFooter && (isMobileDevice() || isTabDevice()),
    'nvc-footer-3d': is3D && !this.isAlternateFooter,
    'nvc-footer-3d-pdp-mobile':
      is3D &&
      fromPDP &&
      !this.isAlternateFooter &&
      (isMobileDevice() || isTabDevice()) &&
      !isthreedPdp,
    'nvc-footer-3d-pdp-tab': is3D && fromPDP && isTabDevice() && isthreedPdp,
    'nvc-footer': !(is3D && !this.isAlternateFooter),
    'sc-padding-bottom-9':
      isRoomPlanner &&
      (isMobileDevice() || isTabDevice()) &&
      !slotService.allRoomItemsHidden &&
      (!isBusinessUser ||
        (isBusinessUser && slotService.roomPlanViewMode === 'SwapProducts')) &&
      (isCartEnabled() ||
        (!isCartEnabled() && slotService.roomPlanViewMode !== 'RoomItems'))
  }"
>
  <div
    [fxLayout]="
      isAlternateFooter
        ? 'column'
        : isMobileDevice() || isTabDevice()
        ? 'column'
        : 'row'
    "
    class="footerC ws-footer-padding"
    fxLayoutAlign="space-between"
    [ngClass]="isAlternateFooter ? 'nvc-margin-50' : ''"
  >
    <div
      [fxFlex]="
        (isMobileDevice() || isTabDevice()) && !isAlternateFooter ? 100 : 30
      "
      fxLayout="column"
      class="footerlogo"
    >
      <div
        [ngClass]="
          (isMobileDevice() || isTabDevice()) && isAlternateFooter
            ? 'nvc-text-align-center'
            : ''
        "
      >
        <img
          *ngIf="whiteShopLogo"
          [ngClass]="{
            'nvc-whiteshop-logo-customized':
              slotService.isCustomized &&
              !slotService.websitePromolinkCB &&
              (isMobileDevice() || isTabDevice()),
            'nvc-whiteshop-logo': !(
              slotService.isCustomized &&
              (isMobileDevice() || isTabDevice())
            ),
            'nvc-whiteshop-logo-srsm':
              slotService.websitePromolinkCB &&
              !(isMobileDevice() || isTabDevice()),
            'nvc-whiteshop-logo-srsm-mobile':
              slotService.websitePromolinkCB &&
              (isMobileDevice() || isTabDevice()),
            'sc-margin-bottom-logo': isAlternateFooter
          }"
          [src]="whiteShopLogo"
          alt="whiteshopLogo"
        />
      </div>
      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        fxFlex.lt-sm="100"
        class="nvc-footer-text-quote ws-text-style"
        [ngClass]="[
          isAlternateFooter ? 'sc-mulish sc-alternate-content' : '',
          (isMobileDevice() || isTabDevice()) && isAlternateFooter
            ? 'sc-line-height nvc-text-align-center sc-padding-none sc-font-mobile-content sc-alternate-content'
            : '',
          isAlternateFooter && !(isMobileDevice() || isTabDevice())
            ? 'sc-pad-bottom-3 sc-address-content-desk sc-text-justify'
            : ''
        ]"
        *ngIf="
          footerText &&
          footerText.length &&
          ((!isEmbedded && (is3D || isSTL) && isHeaderAndFooter) ||
            isAlternateFooter)
        "
      >
        <div id="footertext" class="footer-text-class"></div>
        <!-- 'footer-text-class' this class is not a CSS class only used for getElementsByClassName purpose   -->
      </div>
      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        fxFlex.lt-sm="100"
        [ngClass]="{
          'sc-margin-top-24':
            slotService.websitePromolinkCB &&
            (isMobileDevice() || isTabDevice())
        }"
        *ngIf="
          addresses &&
          addresses.length &&
          !(!isEmbedded && (is3D || isSTL) && isHeaderAndFooter) &&
          !isAlternateFooter
        "
      >
        <div
          fxLayout="row"
          fxLayout.lt-sm="column"
          class="ws-text-style ws-mb-1rem"
        >
          <div
            [ngClass]="{
              'sc-margin-bottom-address':
                slotService.websitePromolinkCB &&
                (isMobileDevice() || isTabDevice())
            }"
            fxLayout="column"
            fxLayoutGap="5px"
          >
            <b class="ws-text-margin">
              {{ addresses[0].title }}
            </b>
            <div class="ws-text-style-3d">
              <div id="addressText" class="address-text-class"></div>
              <!-- 'address-text-class' this class is not a CSS class only used for getElementsByClassName purpose   -->
            </div>
          </div>
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        fxFlex.lt-sm="100"
        *ngIf="
          !(addresses && addresses.length) &&
          !(!isEmbedded && (is3D || isSTL) && isHeaderAndFooter) &&
          !isAlternateFooter
        "
      >
        <div
          fxLayout="row"
          fxLayout.lt-sm="column"
          class="ws-text-style ws-mb-1rem"
        >
          <div fxLayout="column" fxLayoutGap="5px">
            <div class="ws-text-margin">NEW YORK</div>
            <small class="ws-text-margin">
              84 Wooster St., Suite 203 New York, NY 10012 USA
            </small>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="isAlternateFooter"
      [fxLayout]="isMobileDevice() || isTabDevice() ? 'column' : 'row'"
      [fxLayoutAlign]="
        isMobileDevice() || isTabDevice() ? 'start center' : 'start start'
      "
      fxLayoutGap="5%"
      class="sc-mulish"
    >
      <div
        *ngIf="addresses && addresses[0] && addresses[0].title"
        fxLayout="row"
        fxLayout.lt-sm="column"
        class="sc-min-width-30 ws-text-style ws-mb-1rem"
        fxFlex="30"
        [ngClass]="isMobileDevice() || isTabDevice() ? 'sc-margin-top-2' : ''"
      >
        <div
          fxLayout="column"
          class="nvc-width-hundred sc-alternate-content"
          [fxLayoutAlign]="
            isMobileDevice() || isTabDevice() ? 'center center' : 'center'
          "
        >
          <div
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'sc-address-heading-mobile'
                : 'sc-address-heading-desk'
            "
          >
            {{ addresses[0].title }}
          </div>
          <mat-divider
            class="sc-new-footer-color"
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'sc-width-10'
                : 'nvc-width-hundred'
            "
          ></mat-divider>
          <div
            [ngClass]="[
              isMobileDevice() || isTabDevice()
                ? 'nvc-text-align-center sc-font-mobile-content'
                : 'sc-address-content-desk',
              !isAlternateFooter ? 'ws-text-style-3d' : ''
            ]"
          >
            <div
              id="addressTextalternate"
              class="address-text-alternate-class"
            ></div>
            <!-- 'address-text-alternate-class' this class is not a CSS class only used for getElementsByClassName purpose   -->
          </div>
        </div>
      </div>
      <div
        fxLayout.gt-xs="column"
        fxFlex="30"
        class="sc-min-width-30"
        [fxLayoutAlign]="
          isMobileDevice() || isTabDevice() ? 'center center' : 'start'
        "
        *ngIf="emailAddress.length !== 0 || contactNumber.length !== 0"
        [ngClass]="
          isMobileDevice() || isTabDevice() ? 'sc-margin-top-2' : 'ws-mb-1rem'
        "
      >
        <div
          fxLayout="column"
          class="nvc-width-hundred sc-alternate-content"
          [fxLayoutAlign]="
            isMobileDevice() || isTabDevice() ? 'center center' : 'start'
          "
        >
          <div
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'nvc-text-align-center sc-address-heading-mobile'
                : 'sc-address-heading-desk'
            "
          >
            Contact Us
          </div>
          <mat-divider
            class="sc-new-footer-color"
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'sc-width-10'
                : 'nvc-width-hundred'
            "
          ></mat-divider>
          <div
            fxLayout="column"
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'nvc-text-align-center sc-font-mobile-content'
                : 'sc-address-content-desk'
            "
            fxLayoutGap="0.5vh"
          >
            <div *ngIf="emailAddress.length !== 0">
              Email:
              <a [href]="setMailLink()" class="nvc-link">{{ emailAddress }}</a>
            </div>
            <div *ngIf="contactNumber.length !== 0">
              Tel:
              <a [href]="setPhoneLink()" class="nvc-link">{{
                contactNumber
              }}</a>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          instaGramLink ||
          faceBookLink ||
          twitterLink ||
          linkedInLink ||
          youTubeLink
        "
        fxLayout="column"
        [fxLayoutAlign]="
          isMobileDevice() || isTabDevice() ? 'center center' : 'start'
        "
        fxFlex="30"
        class="sc-min-width-30 sc-alternate-content"
        [ngClass]="
          isMobileDevice() || isTabDevice()
            ? 'sc-margin-top-2'
            : 'ws-mb-1rem nvc-width-hundred'
        "
      >
        <div
          [ngClass]="
            isMobileDevice() || isTabDevice()
              ? 'sc-address-heading-mobile'
              : 'sc-address-heading-desk'
          "
        >
          Follow Us On
        </div>
        <mat-divider
          class="sc-new-footer-color"
          [ngClass]="isMobileDevice() || isTabDevice() ? 'sc-width-10' : ''"
        ></mat-divider>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.75rem">
          <a
            class="ws-outline-none sc-text-dec-none"
            [attr.href]="instaGramLink"
            *ngIf="instaGramLink"
            target="_blank"
            rel="noopener noreferrer"
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            <mat-icon
              class="sc-alternate-content sc-new-logo"
              svgIcon="insta_new"
            ></mat-icon>
          </a>
          <a
            class="ws-outline-none sc-text-dec-none"
            [attr.href]="faceBookLink"
            *ngIf="faceBookLink"
            target="_blank"
            rel="noopener noreferrer"
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            <mat-icon
              class="sc-alternate-content sc-new-logo"
              svgIcon="facebook_new"
            ></mat-icon>
          </a>
          <a
            class="ws-outline-none sc-text-dec-none"
            [attr.href]="twitterLink"
            *ngIf="twitterLink"
            target="_blank"
            rel="noopener noreferrer"
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            <mat-icon
              class="sc-alternate-content sc-new-logo"
              svgIcon="twitter_new"
            ></mat-icon>
          </a>
          <a
            class="ws-outline-none sc-text-dec-none"
            [attr.href]="linkedInLink"
            *ngIf="linkedInLink"
            target="_blank"
            rel="noopener noreferrer"
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            <mat-icon
              class="sc-alternate-content sc-new-logo"
              svgIcon="linkedin_new"
            ></mat-icon>
          </a>

          <a
            class="ws-outline-none sc-text-dec-none"
            [attr.href]="youTubeLink"
            *ngIf="youTubeLink"
            target="_blank"
            rel="noopener noreferrer"
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            <mat-icon
              class="sc-alternate-content sc-new-logo"
              svgIcon="youtube_new"
            ></mat-icon>
          </a>
        </div>
      </div>
    </div>

    <div
      fxLayout.gt-xs="row"
      fxLayout.lt-sm="column"
      [fxLayoutAlign]="
        slotService.websitePromolinkCB && !isMobileDevice()
          ? 'space-between start'
          : ''
      "
      fxFlex="60"
      *ngIf="
        isEmbedded ||
        !(
          is3D ||
          isSTL ||
          isRoomPlanner ||
          isHeaderAndFooter ||
          (isAlternateFooter && isCollectionBoard)
        )
      "
    >
      <div
        *ngIf="pageLinks && pageLinks.length"
        fxLayout="column"
        [fxLayoutGap]="isMobileDevice() || isTabDevice() ? '1vh' : ''"
        [fxFlex.gt-sm]="slotService.websitePromolinkCB ? '22' : '40'"
        class="ws-info-section ws-no-wrap"
      >
        <b class="ws-margin-heading"> Information </b>
        <div fxLayout="column" fxLayoutGap="1vh">
          <div *ngFor="let link of pageLinks">
            <a
              [href]="link.link"
              class="ws-text-decoration-none"
              target="_blank"
              >{{ link.title }}</a
            >
          </div>
        </div>
      </div>
      <div
        *ngIf="
          addresses &&
          addresses.length &&
          !isEmbedded &&
          is3D &&
          isHeaderAndFooter &&
          !isAlternateFooter
        "
        fxLayout.gt-xs="column"
        fxFlex.gt-sm="40"
        class="ws-info-section"
      >
        <b class="ws-margin-heading"> Address </b>
        <div fxLayout="column" fxLayoutGap="1vh">
          <div class="ws-text-margin">
            {{ addresses[0].title }}
          </div>
          <small class="ws-text-margin">
            {{ addresses[0].addressLine }}
          </small>
        </div>
      </div>
      <div
        fxLayout.gt-xs="column"
        [fxLayoutGap]="isMobileDevice() || isTabDevice() ? '1vh' : ''"
        [fxFlex.gt-sm]="slotService.websitePromolinkCB ? '20' : '60'"
        class="nvc-contact-info"
        *ngIf="
          (emailAddress?.length !== 0 || contactNumber?.length !== 0) &&
          !isAlternateFooter &&
          !isRoomPlanner
        "
      >
        <b class="ws-margin-heading"> Contact </b>
        <div fxLayout="column" fxLayoutGap="1vh">
          <div *ngIf="emailAddress?.length !== 0">
            <a [href]="setMailLink()" class="nvc-link">{{ emailAddress }}</a>
          </div>
          <div *ngIf="contactNumber?.length !== 0">
            <a [href]="setPhoneLink()" class="nvc-link">{{ contactNumber }}</a>
          </div>
        </div>
      </div>
      <div
        *ngIf="slotService.websitePromolinkCB && mapUrl"
        class="sc-mapouter sc-max-width-hundred"
        [ngClass]="{
          'sc-mapouter-tab': isTabDevice()
        }"
        fxFlex.gt-sm="50"
      >
        <div class="sc-gmap-canvas nvc-width-hundred">
          <iframe
            class="nvc-width-hundred"
            width="400"
            height="250"
            id="gmap_canvas"
            [src]="mapUrl"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
          >
          </iframe>
        </div>
      </div>
    </div>
    <div
      [fxLayout]="!(isMobileDevice() || isTabDevice()) ? 'row' : 'column'"
      fxFlex="65"
      *ngIf="
        footerContent &&
        footerContent.length &&
        !isEmbedded &&
        (isSTL || isRoomPlanner || is3D) &&
        isHeaderAndFooter &&
        !isAlternateFooter
      "
    >
      <div
        fxLayout.gt-xs="column"
        [fxFlex.gt-sm]="100 / footerContent.length"
        class="ws-info-section"
        [ngClass]="{ 'ws-info-section-tab': isTabDevice() }"
        *ngFor="let item of footerContent"
        fxLayoutGap="1vh"
      >
        <div class="ws-margin-heading ws-bold">{{ item.title }}</div>
        <div
          class="ws-text-style-3d"
          [innerHTML]="refineText(item.description)"
        ></div>
      </div>
    </div>
  </div>
  <div class="ws-base-footer">
    <div
      class="nvc-margin-top"
      fxLayout.gt-xs="row"
      fxLayout.lt-sm="row wrap"
      fxLayoutGap.gt-xs="1.5rem"
      fxLayoutAlign="start center"
      [ngClass]="isMobileDevice() || isTabDevice() ? 'sc-bottom-img' : ''"
    >
      <div
        fxHide.lt-sm
        fxLayout.gt-xs="column"
        fxFlex.gt-xs="63"
        [ngClass]="
          isMobileDevice() || isTabDevice()
            ? 'ws-poweredby-div-mobile'
            : 'ws-poweredby-div'
        "
        *ngIf="!(!isEmbedded && (is3D || isSTL) && isHeaderAndFooter)"
      >
        <div
          fxLayout.gt-xs="row"
          [fxLayoutAlign]="isTabDevice() ? 'start center' : ''"
        >
          <span
            class="nvc-margin-powered-by"
            [ngClass]="
              (isMobileDevice() || isTabDevice()) && isAlternateFooter
                ? 'sc-margin-top-4'
                : ''
            "
            >Powered by </span
          ><img
            (click)="redirectPoweredBy()"
            class="ws-cursor-pointer ws-shopconnect-logo"
            [ngClass]="
              (isMobileDevice() || isTabDevice()) && isAlternateFooter
                ? 'sc-height-25'
                : ''
            "
            [src]="shopConnectLogo"
            alt="Logo"
          />
        </div>
      </div>
      <div
        fxHide.lt-sm
        fxLayout.gt-xs="column"
        fxFlex.gt-xs="80"
        class="ws-3d-poweredby-div"
        *ngIf="!isEmbedded && (is3D || isSTL) && isHeaderAndFooter"
      >
        <div
          fxLayout.gt-xs="row"
          [fxLayoutAlign]="isTabDevice() ? 'start center' : ''"
        >
          <span
            class="nvc-margin-powered-by"
            [ngClass]="
              (isMobileDevice() || isTabDevice()) && isAlternateFooter
                ? 'sc-margin-top-4'
                : ''
            "
            >Powered by </span
          ><img
            (click)="redirectPoweredBy()"
            class="ws-cursor-pointer ws-shopconnect-logo"
            [ngClass]="
              (isMobileDevice() || isTabDevice()) && isAlternateFooter
                ? 'sc-height-25'
                : ''
            "
            [src]="
              is3D && !isAlternateFooter
                ? shopConnectLogoWhite
                : shopConnectLogo
            "
            alt="Logo"
          />
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="nvc-social-icon-container"
        *ngIf="!isAlternateFooter"
      >
        <a
          class="ws-outline-none"
          [attr.href]="faceBookLink"
          *ngIf="faceBookLink"
          target="_blank"
          rel="noopener noreferrer"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <img
            [src]="fbFooterLogoColored"
            alt="fbLogo"
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'nvc-social-logo-img-mobile'
                : 'nvc-social-logo-img'
            "
          />
        </a>
        <a
          class="ws-outline-none"
          [attr.href]="twitterLink"
          *ngIf="twitterLink"
          target="_blank"
          rel="noopener noreferrer"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <img
            [src]="twitterFooterLogoColored"
            class="sc-margin-top-5"
            alt="twitterLogo"
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'nvc-social-logo-img-mobile'
                : 'nvc-social-logo-img'
            "
          />
        </a>
        <a
          class="ws-outline-none"
          [attr.href]="linkedInLink"
          *ngIf="linkedInLink"
          target="_blank"
          rel="noopener noreferrer"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <img
            [src]="linkedInFooterLogoColored"
            class="sc-margin-bottom-3"
            alt="linkedInLogo"
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'nvc-social-logo-img-mobile'
                : 'nvc-social-logo-img'
            "
          />
        </a>
        <a
          class="ws-outline-none"
          [attr.href]="instaGramLink"
          *ngIf="instaGramLink"
          target="_blank"
          rel="noopener noreferrer"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <img
            [src]="instagramFooterLogoColored"
            class="sc-margin-top-5"
            alt="instagramLogo"
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'nvc-social-logo-img-mobile'
                : 'nvc-social-logo-img'
            "
          />
        </a>
        <a
          class="ws-outline-none"
          [attr.href]="youTubeLink"
          *ngIf="youTubeLink"
          target="_blank"
          rel="noopener noreferrer"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <img
            [src]="youTubeFooterLogoColored"
            class="sc-margin-top-5"
            alt="youtubeLogo"
            [ngClass]="
              isMobileDevice() || isTabDevice()
                ? 'nvc-social-logo-img-mobile'
                : 'nvc-social-logo-img'
            "
          />
        </a>
      </div>
      <div
        fxHide.gt-xs
        [ngClass]="
          !isEmbedded && (is3D || isSTL) && isHeaderAndFooter
            ? 'ws-3d-poweredby-div'
            : isMobileDevice() || isTabDevice()
            ? 'ws-poweredby-div-mobile'
            : 'ws-poweredby-div'
        "
      >
        <div
          fxLayout="row"
          [fxLayoutAlign]="isTabDevice() ? 'start center' : ''"
        >
          <span
            class="nvc-margin-powered-by"
            [ngClass]="
              (isMobileDevice() || isTabDevice()) && isAlternateFooter
                ? 'sc-margin-top-4'
                : ''
            "
            >Powered by </span
          ><img
            (click)="redirectPoweredBy()"
            class="ws-cursor-pointer ws-shopconnect-logo"
            [ngClass]="
              (isMobileDevice() || isTabDevice()) && isAlternateFooter
                ? 'sc-height-25'
                : ''
            "
            [src]="
              is3D && !isAlternateFooter
                ? shopConnectLogoWhite
                : shopConnectLogo
            "
            alt="Logo"
          />
        </div>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div
    class="ws-base-footer ws-info-section"
    *ngIf="
      seoContent &&
      seoContent.length &&
      !isEmbedded &&
      isHeaderAndFooter &&
      (isRoomPlanner || isSTL || is3D) &&
      !isAlternateFooter
    "
    fxLayout.gt-xs="column"
    fxFlex.gt-sm="40"
  >
    <div *ngFor="let item of seoContent" class="nvc-seo-content">
      <div fxLayout="column" fxLayoutGap="1vh">
        <div class="ws-text-margin nvc-seo-text-font">
          {{ item.title }}
        </div>
        <small class="ws-text-style-3d" [innerHTML]="item.content"></small>
      </div>
    </div>
  </div>
</div>
